const HEADER_CONTENT_TYPE = 'application/json ; charset=utf-8';
const HEADER_ACCEPT = 'application/json ; charset=utf-8';
const HEADER_CONTENT_ENCODING = 'gzip';
const DEVICE_TYPE = 'DESKTOP';
const API_SERVICE_DOMAIN = ssr.isOnClient
  ? '//holidayservice.makemytrip.com/HolidayServices/service'
  : 'http://holidayservice.mmt.mmt/HolidayServices/service';
const HTTP_POST = 'POST';
const CHANNEL = 'B2CNLR';
const MOBILE_CHANNEL = 'raw_mobile';
const WEBSITE = 'IN';
const LS_LOCATION = 'location';
const FUNNEL = 'HLD';
const AFFILIATE = 'MMT';
const LOB = 'Holidays';
const FUNNEL_BINDING_KEY = 'funnel_binding_keyV2';
export {
  API_SERVICE_DOMAIN,
  HEADER_ACCEPT,
  HEADER_CONTENT_TYPE,
  HEADER_CONTENT_ENCODING,
  DEVICE_TYPE,
  HTTP_POST,
  CHANNEL,
  WEBSITE,
  AFFILIATE,
  FUNNEL,
  LS_LOCATION,
  LOB,
  MOBILE_CHANNEL,
  FUNNEL_BINDING_KEY,
};
